import {UsageFooter} from 'shells/navigation/secondary-sidebar/usage-footer-new';

import {LimitedType} from 'nutshell-graphql-types';
import type {AiFeatureType} from 'nutshell-graphql-types';

import {appHistory} from '../../history';

import {useGetLimitsByType, getUsageFromLimits} from '../limits';

// The unlock percentage point in which we promote a plan upgrade
const APPROACHING_LIMIT_PERCENT = 0.9;

interface Props {
    aiFeatureType: AiFeatureType;
}

export function AiCreditUsageFooter(props: Props) {
    const {limits, isLoading} = useGetLimitsByType(
        NutClientConfig.hasAiOutcomesFF ? LimitedType.AI_OUTCOMES : LimitedType.AI_SUMMARIES
    );
    const monthlyUsage = getUsageFromLimits(limits);

    if (isLoading || !monthlyUsage) {
        return null;
    }

    const {limit, currentUsage} = monthlyUsage;

    // As of 4/21/2025, these features are available across all plans
    // but keeping this here and making it super linent for future reference
    const featureGated =
        !NutClientConfig.hasZoomTranscription && !NutClientConfig.hasGoogleMeetTranscription;

    return (
        <UsageFooter
            type='ai'
            usage={currentUsage}
            limit={limit || 0}
            approachingLimitPercent={APPROACHING_LIMIT_PERCENT}
            isBeta={NutClientConfig.hasNutshellInboxBeta}
            featureGated={featureGated}
            onClickFeatureGate={() => {
                appHistory.push('/setup/billing/sales');
            }}
            aiFeatureType={props.aiFeatureType}
        />
    );
}
